import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faFolderTimes } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import EnabledPermission from '@components/EnabledPermission'

type TemplatesToolsProps = {
  urls: {
    agencyAdminManageTemplatesUrl: string,
    agencyMarketingIndexUrl: string,
    agencyMarketingSelectTemplateUrl: string,
  },
}

const TemplatesTools = (props: TemplatesToolsProps) => {
  const { urls } = props
  const {
    agencyAdminManageTemplatesUrl,
    agencyMarketingIndexUrl,
  } = urls || {}

  return (
    <Tools>
      <Button
        // @ts-expect-error TS2322
        as="a"
        buttonStyle="secondaryUtility"
        href={agencyMarketingIndexUrl}
        icon={<FontAwesomeIcon icon={faFolderTimes} />}
        size="medium"
      >
        Change Tag
      </Button>

      <EnabledPermission permissionKey="admin.agency_admin_pages.manage">
        <Button
          // @ts-expect-error TS2322
          as="a"
          buttonStyle="secondaryUtility"
          href={agencyAdminManageTemplatesUrl}
          icon={<FontAwesomeIcon icon={faEdit} />}
          marginTop="medium"
          size="medium"
        >
          Manage Templates
        </Button>
      </EnabledPermission>
    </Tools>
  )
}

export default TemplatesTools
